import { render, staticRenderFns } from "./inSaleClaimIndemnity.vue?vue&type=template&id=10568750&scoped=true&"
import script from "./inSaleClaimIndemnity.vue?vue&type=script&lang=js&"
export * from "./inSaleClaimIndemnity.vue?vue&type=script&lang=js&"
import style0 from "./inSaleClaimIndemnity.vue?vue&type=style&index=0&id=10568750&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10568750",
  null
  
)

export default component.exports